export default "__VITE_ASSET__DAVhTQ8C__"